var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function SettingsIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3H16C18.2091 3 20 4.79086 20 7C20 9.20914 18.2091 11 16 11H8C5.79086 11 4 9.20914 4 7C4 4.79086 5.79086 3 8 3ZM20 17C20 14.7909 18.2091 13 16 13H8C5.79086 13 4 14.7909 4 17C4 19.2091 5.79086 21 8 21H16C18.2091 21 20 19.2091 20 17ZM6 17C6 15.8954 6.89543 15 8 15H12.8912C12.337 15.5308 12 16.2316 12 17C12 17.7684 12.337 18.4692 12.8912 19H8C6.89543 19 6 18.1046 6 17ZM11.1088 9H16C17.1046 9 18 8.10457 18 7C18 5.89543 17.1046 5 16 5H11.1088C11.663 5.53076 12 6.23165 12 7C12 7.76835 11.663 8.46924 11.1088 9Z", fill: "" })));
}
export var SettingsIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: SettingsIconInner }, props))); };
//# sourceMappingURL=SettingsIcon.js.map